import { render, staticRenderFns } from "./File.vue?vue&type=template&id=0018ce0b"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0018ce0b')) {
      api.createRecord('0018ce0b', component.options)
    } else {
      api.reload('0018ce0b', component.options)
    }
    module.hot.accept("./File.vue?vue&type=template&id=0018ce0b", function () {
      api.rerender('0018ce0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/File.vue"
export default component.exports